/**
 * Builds a Google Maps search URL for the given coordinates.
 * Returns an empty string if coordinates are missing or zero.
 */
export const buildGoogleMapsUrl = (latitude, longitude) => {
  const lat = Number(latitude);
  const lng = Number(longitude);

  if (
    !Number.isFinite(lat) ||
    !Number.isFinite(lng) ||
    (lat === 0 && lng === 0)
  ) {
    return "";
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${lat},${lng}`
  )}`;
};